import { connect } from "react-redux";
import { IDataStorage } from "../../core";
import { InputSwitch, Panel } from "../prime";
import styles from "./index.module.scss";

type IProps = {
  storage: IDataStorage;
  children?: string | JSX.Element | JSX.Element[] | (() => JSX.Element);
  readonly?: boolean;
  checked?: boolean;
  onChange?: (checked: boolean) => void;

  title?: string;
  title_sd?: string;

  offContent?: string | JSX.Element | JSX.Element[] | (() => JSX.Element);
  onContent?: string | JSX.Element | JSX.Element[] | (() => JSX.Element);
}

export default connect((s:any) => ({ storage:s.main }))(({ 
  storage, children, readonly, checked, onChange,
  title, title_sd, onContent, offContent
} : IProps) => {

  return <>
    <Panel
      className={styles.panel}
      header={<>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div>
            <InputSwitch className={styles.switch} checked={checked} onChange={e => !!onChange && onChange(e.value)} disabled={readonly} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: 12 }}>
            <span className={styles.title}>{title}</span>
            <span className={styles.title_sd}>{title_sd}</span>
          </div>
        </div>
      </>}
      style={{ marginBottom: 20 }}
    >
      {(!!checked ? onContent : offContent) ?? children}
    </Panel>
  </>
});